// @flow
import type {
  MatchCard,
} from '../../match/types';
import type { SessionMeta } from '../../types';
import uniqBy from 'lodash/uniqBy';
import flatMap from 'lodash/flatMap';

import {
  calcTimeFactor,
  getNewScoreMatch,
  getExpectedTimeMatch,
  normalizeScore,
  getScorePenalty,
} from './utils';

const matchScoring = (
  numUnansweredItems: number,
  answers: MatchCard[],
  timeTaken: number,
  correct: boolean,
  sessionMeta: SessionMeta,
  rightMatchId: string,
) => {
  // The probability of guessing a correct match pair
  const probabilityGuessCorrect = 1 / (numUnansweredItems - 1);
  // console.log('NEW ANSWER -----------------------------');
  // console.log('NUM UNANSWERED', numUnansweredItems);
  // console.log('PROB GUESS CORRECT', probabilityGuessCorrect);
  // Speed: Faster matching means more confident
  const timeExpected = getExpectedTimeMatch(answers);
  // Provides a factor (0-1) whether the user's answer was fast or slow
  const timeFactor = calcTimeFactor(timeTaken, timeExpected / 1000);
  // console.log('TIME FACTOR', timeFactor);

  const getFactsFromMatchPair = () => {
    const correctMatches = answers.map(({
      matches,
    }) => matches.map(({
      factId,
      currentScore,
      termId,
      contentId,
      previousScore,
    }) => ({
      id: factId,
      currentScore: currentScore ? currentScore.value : 0,
      previousScore: previousScore ? previousScore.value : 0,
      termId,
      contentId,
    })));
    return uniqBy(flatMap(correctMatches), 'id');
  };

  const facts = getFactsFromMatchPair();
  // console.log('facts', { facts });

  const itemsMeta = sessionMeta[rightMatchId];
  const scores = facts.map<any, any>(fact => {
    const {
      currentScore, id, termId, contentId, previousScore,
    } = fact;
    const newScore = getNewScoreMatch({
      currentScore,
      correct,
      timeFactor,
      probabilityGuessCorrect,
    });
    //  console.log('NEW SCORE', newScore);
    const penalty = itemsMeta ? getScorePenalty(
      correct,
      itemsMeta.numSuccessAttempts,
      itemsMeta.numTotalAttempts,
      (new Date().valueOf() - new Date(itemsMeta.lastTime).valueOf()) / 1000,
    ) : 0;
    const score = normalizeScore(newScore - penalty);
    // console.log('PENALTY', penalty);
    // console.log('**FINAL SCORE**', score);
    return {
      factId: id,
      score,
      timeFactor,
      termId,
      contentId,
      previousScore,
    };
  });
  // Returns array of objects from above
  return scores;
};

export default matchScoring;
